import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { sendMobileErrorNotification } from '@ecs-uk/web-common-mobile-view-helpers';
import ThanksLanding from '../../thanks/landing';

const MobileThanksLandingPage = ({ isBlockedByKillSwitch = false }) => {
  useEffect(() => {
    if (isBlockedByKillSwitch) {
      sendMobileErrorNotification();
    }
  }, [isBlockedByKillSwitch]);

  if (isBlockedByKillSwitch) {
    return null;
  }

  return <ThanksLanding isWebview={true} />;
};

MobileThanksLandingPage.propTypes = {
  isBlockedByKillSwitch: PropTypes.bool,
};

export default MobileThanksLandingPage;
